import { navigate } from "gatsby";

import create from "zustand";

import { errorAwareApiFetch } from "../../../../../apiBindings";
import { storageLocal as storage } from "../../../../../utils/StorageHandler";
import createFormErrorSlices from "../../../../../utils/store/formErrors";
import resolveWebView from "../../../../../utils/webViewRedirect";
import iCheckoutData from "../../interfaces/iCheckoutData";
import iNotify from "../../interfaces/iNotify";

interface iHeatingOilStepProductChoice {
    productIsPremium: boolean;
    productChanged: number;
    setProductIsPremium: (productIsPremium: boolean) => void;
    productHasChanged: () => void;
    storeProductIsPremiumToStorage: () => void;
    storeProductToServer: (
        checkoutData: iCheckoutData,
        notify: iNotify,
        calculateOnly: boolean,
        isOverview: boolean,
        onSuccess: () => void | undefined
    ) => Promise<iCheckoutData>;
    errors: string[];
    setErrors: (errors: string[]) => void;
    addError: (error: string) => void;
    clearError: (error: string) => void;
    hasErrorAt: (error: string) => boolean;
}

const useStore = create<iHeatingOilStepProductChoice>((set, get) => ({
    ...createFormErrorSlices(set, get),
    productIsPremium: storage.getBoolean("hel:product-is-premium"),
    productChanged: 0,

    setProductIsPremium: (productIsPremium: boolean) => {
        set({ productIsPremium: productIsPremium });
    },

    productHasChanged: () => {
        set({ productChanged: get().productChanged + 1 });
    },

    storeProductIsPremiumToStorage: () => {
        storage.set("hel:product-is-premium", get().productIsPremium);
    },

    setProductIsPremiumStorageToState: () => {
        set({ productIsPremium: storage.getBoolean("hel:product-is-premium") });
    },

    produktStepIsValid: () => {
        return true;
    },

    storeProductToServer: async (
        checkoutData,
        notify,
        calculateOnly = false,
        isOverview = false,
        onSuccess
    ): Promise<iCheckoutData> => {
        set({ errors: [] });
        let checkoutDataResponse = { ...checkoutData };
        await errorAwareApiFetch<{ data: any }>(
            `/heatingoil/checkout/product`,
            {
                method: "POST",
                body: JSON.stringify({
                    hash: checkoutData.user_hash,
                    productIsPremium: get().productIsPremium,
                    calculateOnly: calculateOnly,
                }),
            }
        )
            .then(({ data }) => {
                checkoutDataResponse = data;
                if (onSuccess) {
                    onSuccess();
                }
            })
            .catch(({ data }) => {
                const errors = Object.keys(data.errors);
                set({ errors: errors });
                notify("Fehlgeschlagen", data.message);
                if (!isOverview) {
                    navigate(resolveWebView("/heizoel/bestellung/produkt/"));
                }
            });
        return checkoutDataResponse;
    },
}));

export default useStore;
